export function splitPlaceholderText(text, placeholder) {
  let preText, afterText

  if (text.includes(placeholder)) {
    preText = text.substr(0, text.indexOf(placeholder))
    afterText = text.substr(text.indexOf(placeholder) + placeholder.length, text.length)
  }

  return { preText, afterText }
}

/**
 * Safely decodes HTML encoded string to plain text using browser native DOMParser API (see https://developer.mozilla.org/de/docs/Web/API/DOMParser)
 * e.g. "<em>Uuml;berschrift</em>" => "Überschrift"
 * @param {*} input HTML encoded string
 * @returns plain text as string
 */
export function decodeHtmlToText(input) {
  const doc = new DOMParser().parseFromString(input, 'text/html')
  return decodeURIComponent(doc.documentElement.textContent)
}

export function getHeadlineText(headline, className) {
  return headline?.text?.replace(/%PLACEHOLDER%/, `<span class="${className}">${headline?.placeholder?.text}</span>`)
}
